import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'

import { PacientesListWrapper } from './pacientes-list/PacientesList'

const PacientesPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='pacientes'
          element={
            <>
              <PageTitle description={t('pagina.pacientes.descricao')}>Pacientes</PageTitle>
              <PacientesListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/pacientes-management/pacientes' />} />
    </Routes>
  )
}

export default PacientesPage
